import React from 'react';
import { GlobalDesignActionPanel } from '../types';
import { AutomaticPanel } from '../../automaticPanel/AutomaticPanel';

const TextStyles: GlobalDesignActionPanel = (props) => {
  return <AutomaticPanel host={props.host} />;
};

export default TextStyles;
